export default {
    user: null,
    quote:null,
    isLogged: false,        
    error: false,
    errorMessage: '',
    isLoadingAuth: false,
    token: null,
    queryParams: null    
}